//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import EmptyTip from '@/components/views/empty_tip'
import CommonImg from '@/components/views/common_img'
import CommonTabs from './_tabs'
import TopRightShare from '@/components/views/top_right_share'
import BottomRightShare from '@/components/views/bottom_right_share'

import detailSubPage from '@/common/mixins/detailSubPage'

import vr_tip from './mixin/vr_tip'
import audio from './mixin/audio'

import Service from '@/service/building'
import CommonService from '@/service'

import LayoutItem from './_layout_item'
import VrTip from './_vr_tip'
import CommonFooter from '../_components/_common_footer'
import Consultants from '@/components/business/_excellent_consultants'

import LayoutTip from '@/views/building/_components/_layout_tip'

import { handleImgSize } from '@/common/utils/map_view_data'

export default {
    mixins: [
        detailSubPage,
        vr_tip,
        audio
    ],
    name: 'HOUSE_IMG_PREVIEW',
    data () {
        return {
            loading: true,
            all_urls: [],
            urls: [],
            preview_urls: [],
            common_tabs: [],
            select_tab: '',
            type: '',
            house_ids: '',
            building_id: '',
            title: '',
            excellent_consultants: [],
            building: {},
            bedrooms: '',
            common_urls: [],
            scrolling: false,
            tab_height: 0,
            ObserverMap: [],
            favourite: false
        }
    },
    watch: {
        loading: {
            handler (latest) {
                if (latest) {
                    this.$wx.showLoading()
                } else {
                    this.$wx.hideLoading()
                }
            },
            immediate: true
        }
    },
    computed: {
        bedroom_tabs () {
            if (this.type === 'layout') {
                const num_map = {}
                return this.urls.reduce((prev, { bedrooms }) => {
                    if (bedrooms) {
                        if (!num_map[bedrooms]) {
                            num_map[bedrooms] = 0
                        }
                        num_map[bedrooms]++
                        if (prev.indexOf(bedrooms) === -1) {
                            prev.push(bedrooms)
                        }
                    }
                    return prev
                }, []).sort().map((bedrooms) => {
                    return {
                        bedrooms,
                        count: num_map[bedrooms]
                    }
                })
            }
        },
        layout_urls () {
            if (this.bedrooms) {
                return this.urls.filter(({ bedrooms }) => {
                    return bedrooms === this.bedrooms
                })
            }
            return this.urls
        },
        show_empty () {
            if (this.type === 'common') {
                return !this.loading && !this.common_urls.length
            }
            return !this.loading && !this.urls.length
        },
        show_vr_tip () {
            return this.urls.some(({ vr_url }) => Boolean(vr_url))
        },
        vr_list_link () {
            return `/building/vr?building_id=${this.building_id}&title=${this.building.name}`
        },
        show_disclaimer () {
            return this.building.activities && this.building.activities.indexOf('vr_disclaimer') > -1
        },
        show_planar_graph() {
            return this.type && this.type === 'layout' && this.building.planar_graph_url
        }
    },
    created () {
        const { building_id, title, type, house_id } = this.$route.query
        this.building_id = building_id
        this.house_ids = house_id ? house_id.split(',').map(id => Number(id)) : '0'
        this.title = title
        this.type = type
        this.getData()
    },
    methods: {
        changeFavourite () {
            this.favourite = !this.favourite
        },
        goLocation () {
            this.$router.push({
                path: `/building/planar_graph?building_id=${this.building_id}`
            })
        },
        previewCommonImg (i, j) {
            const item = this.common_urls[i]
            const url = item.urls[j]
            if (item.type === 'video') {
                const { type, building_id, title } = this.$route.query
                this.$router.push({
                    path: `/building/video?building_id=${building_id}&title=${title}&src=${url.medium_url}`
                })
            } else {
                this.$wx.previewImage({
                    current: url.orginal_url,
                    urls: item.urls.map(({ orginal_url }) => orginal_url)
                })
            }
        },
        selectBedrooms (bedrooms) {
            this.bedrooms = bedrooms
        },
        previewPriceImg (index) {
            this.$wx.previewImage({
                current: this.all_urls[index],
                urls: this.all_urls
            })
        },
        getData () {
            const { id, type, building_id, house_id } = this.$route.query
            if (type === 'price') {
                CommonService.getBuilding(building_id, house_id).then((data) => {
                    this.favourite = Boolean(data.follow_info && data.follow_info.id)
                    this.building = data
                    this.title = `${data.name}-房源表`
                    const { price_imgs } = data.current_houses[0].attachment_urls
                    this.all_urls =  price_imgs
                    this.urls = price_imgs.map((url) => {
                        return {
                            orginal_url: `${url}`,
                            image_url: handleImgSize(url, 670, 600)
                        }
                    })
                    this.preview_urls = price_imgs.map((image_url) => {
                        return {
                            image_url
                        }
                    })
                })
                this.title = '房源表'
                this.tabs = [this.title]
                this.select_tab = this.title
                return
            } else {
                CommonService.getBuilding(building_id, house_id).then((data) => {
                    this.favourite = Boolean(data.follow_info && data.follow_info.id)
                    this.building = data
                })
            }
            Service.getImgs(building_id, type).then(data => {
                const detailParam = encodeURIComponent(`building_id=${building_id}`)
                const building = data.building
                data.items.forEach((item) => {
                    if (item.vr_url) {
                        item.vr_link = `/building/web_vr?building_id=${building_id}&link=${encodeURIComponent(item.vr_url)}&title=${building.name}&detailParam=${detailParam}&category_id=${item.id}`
                    }
                })
                this.all_urls = data.items
                this.loading = false
                if (type === 'layout') {
                    this.handleLayoutImg()
                } else {
                    let common_urls = []
                    const { videos } = data.building
                    if (videos && videos.length) {
                        const default_cover = data.items && data.items.length ? data.items[0].image_url : ''
                        videos.forEach((item) => {
                            if (!item.cover_image_url) {
                                item.cover_image_url = default_cover
                            }
                        })
                        common_urls.push({
                            id: 'video',
                            title: '视频',
                            type: 'video',
                            urls: videos
                        })
                    }
                    const tabs = [
                        {
                            key: 'common_tab_1',
                            name: '效果图'
                        },
                        {
                            key: 'common_tab_2',
                            name: '样板间'
                        },
                        {
                            key: 'common_tab_3',
                            name: '实景图'
                        },
                        {
                            key: 'common_tab_4',
                            name: '周边图'
                        }
                    ]
                    const imgs = tabs.reduce((prev, tab, i) => {
                        const urls = data.items.filter(({ subcategory }) => subcategory === tab.name )
                        if (urls && urls.length) {
                            prev.push({
                                id: tab.key,
                                title: tab.name,
                                type: 'img',
                                urls
                            })
                        }
                        return prev
                    }, [])
                    common_urls.push(...imgs)
                    this.common_urls = common_urls
                    this.common_tabs = this.common_urls.map((item) => {
                        return {
                            key: item.id,
                            name: `${item.title}(${item.urls.length})`
                        }
                    })
                    this.select_tab = this.common_tabs[0].key
                    setTimeout(() => {
                        this.getTabHeight()
                    })
                }
                this.getConsultants(data.building.id)
            })
        },
        handleLayoutImg () {
            const house_ids = this.house_ids
            const urlHasHouseId = this.all_urls.some(({ house_id }) => house_ids.indexOf(house_id) > -1)
            let tabs = []
            if (!urlHasHouseId) {
                this.select_tab = '楼盘全部户型'
                tabs = ['楼盘全部户型']
            } else {
                this.select_tab = '本次开盘户型'
                tabs = ['本次开盘户型', '楼盘全部户型']
            }
            this.common_tabs = tabs.map((key) => {
                return {
                    key,
                    name: key
                }
            })
            this.getLayoutUrls()
        },
        handlerUrls (urls) {
            this.urls = urls
            this.preview_urls = urls
        },
        getLayoutUrls () {
            const house_ids = this.house_ids
            let urls = this.all_urls
            if (this.select_tab === '本次开盘户型') {
                urls = this.all_urls.filter(({ house_id }) => {
                    return house_ids.indexOf(house_id) > -1
                })
            }
            this.resetAudioPlaying(this.all_urls)
            this.handlerUrls(urls)
        },
        getTabHeight () {
            const ele = document.querySelector('#top-module-tabs')
            this.tab_height = ele.offsetHeight
            this.initTabs()
        },
        initTabs () {},
        changeTab (tab) {
            if (this.type === 'price') {
                return
            }
            this.select_tab = tab
            if (this.type === 'layout') {
                this.selectBedrooms('')
                this.getLayoutUrls()
            } else {
                const tab_ele = document.querySelector(`#${tab}`)
                console.log('tab', tab, tab_ele, this.tab_height)
                const { offsetTop } = tab_ele
                const rs = offsetTop - this.tab_height
                this.scrolling = true
                window.scrollTo(0, rs)
                this.scrolling = false
            }
        },
        preview (index) {
            this.$wx.previewImage({
                current: this.layout_urls[index].orginal_url,
                urls: this.layout_urls.map(({ orginal_url }) => orginal_url)
            })
        },
        getConsultants (id) {
            Service.excellentConsultants(id).then((data) => {
                this.excellent_consultants = data.slice(0, 3)
            })
        },
        goConsultants () {
            const { id, name } = this.building
            this.$router.push({
                path:`/consultants/filter/main?id=${id}&name=${name}&from=${this.type === 'layout' ? '户型图' : '楼盘图'}`
            })
        },
        goVideo (src) {
            const { id, name } = this.building
            this.$router.push({
                path:`/building/video?building_id=${id}&title=${name}&src=${src}`
            })
        }
    },
    components: {
        VrTip,
        TopRightShare,
        LayoutTip,
        EmptyTip,
        CommonImg,
        CommonTabs,
        CommonFooter,
        Consultants,
        LayoutItem,
        BottomRightShare
    }
}
